import React from 'react';
import { useMemberExportsLocked } from '../../hooks/useMemberExportsLocked';
import { MemberExportNotice } from '../membership/MemberExportNotice';

export interface PublicationFigureDownloadsProps {
  onCsv?: () => void;
  onPng?: () => void | Promise<void>;
  csvDisabled?: boolean;
  pngDisabled?: boolean;
  busy?: boolean;
  /** Accessibility label for the button group */
  ariaLabel?: string;
}

/**
 * PNG / CSV row placed directly below the figure, right-aligned (Statewide Analysis styling).
 */
export const PublicationFigureDownloads: React.FC<PublicationFigureDownloadsProps> = ({
  onCsv,
  onPng,
  csvDisabled,
  pngDisabled,
  busy,
  ariaLabel = 'Download figure',
}) => {
  const exportsLocked = useMemberExportsLocked();
  const showCsv = typeof onCsv === 'function';
  const showPng = typeof onPng === 'function';
  if (!showCsv && !showPng) return null;

  if (exportsLocked) {
    return <MemberExportNotice variant="compact" />;
  }

  return (
    <div className="publication-figure-downloads" role="group" aria-label={ariaLabel}>
      {showPng && (
        <button
          type="button"
          className="publication-figure-download-btn"
          onClick={() => void Promise.resolve(onPng!())}
          disabled={busy || pngDisabled}
        >
          PNG
        </button>
      )}
      {showCsv && (
        <button
          type="button"
          className="publication-figure-download-btn"
          onClick={onCsv}
          disabled={busy || csvDisabled}
        >
          CSV
        </button>
      )}
    </div>
  );
};
